<template>
  <div>
    <div class="mt-5">
      <h4>{{$t('CONTENT.indexation.indexation')}}</h4>
      <div class="row mt-2 b-form__container_type_flex b-form__row_type_flex-end">
        <div class="col-4">
          <label>{{$t('CONTENT.indexation.indexation_kind')}}:<span class="b-form__required"> *</span></label>
          <cool-select :list="availableIndexations"
                       option-value="id"
                       option-text="name"
                       :placeholder="$t('CONTENT.choose')"
                       :isError="isFieldWithError('indexationKindId', indexationKindId)"
                       v-model="indexationKindId"></cool-select>
        </div>
        <div class="col-2">
          <label>{{$t('CONTENT.indexation.firstIndexationDate')}}:</label>
          <datepicker class="b-datepicker" v-model="firstIndexationDate" :disabled="isDisabledIndexationDate" :formatter="datepickerFormat" :disabled-date="disabledDate"/>
        </div>
        <div class="col-2">
          <label>{{$t('CONTENT.percent')}}:</label>
          <numeric class="b-numeric" controls :min="0" :max="100" :disabled="isDisabledIndexationPercent" v-model="indexationPercent"></numeric>
        </div>
        <div class="col-3">
          <label for="comment">{{$t('CONTENT.comment')}}:</label>
          <input type="text" id="comment" class="b-input" v-model="payment.indexation.commentary" :disabled="isDisabledIndexationComment">
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import dateConverter from "../../../utils/converters/date.converter";
import datepickerFormat from '@/mixins/datepickerFormat.mixin';

export default {
  props: {
    lessorComponentSharesIndex: {
      type: Number,
      required: true,
    },
    payment: {
      type: Object
    },
    paymentIndex: {
      type: Number
    },
    assetComponentIndex: {
      type: Number
    },
    assetIndex: {
      type: Number
    },
    paymentsName: {
      type: Array,
    },
    validationErrors: {
      type: Array
    }
  },
  mixins: [datepickerFormat],
  data() {
    return {
      isDisabledIndexationDate: false,
      isDisabledIndexationPercent: false,
      isDisabledIndexationComment: false,
      availableIndexations: [],
    }
  },
  created() {
    this.availableIndexations = this.allIndexations;
  },
  watch: {
    'payment.paymentNameId'(newVal) {
      if(newVal !== null) {
        this.availableIndexations = [];

        for (let i = 0; i < this.paymentsName.length; i++) {
          let currentPaymentNameTypeCode = this.paymentsName[i].paymentTypeCode;
          let currentPaymentNameKindCode = this.paymentsName[i].paymentKindCode;

          let isPaymentWithoutIndexation = currentPaymentNameTypeCode === 'penalty_payment' ||
            currentPaymentNameTypeCode === 'residual_value_guarantees' ||
            currentPaymentNameTypeCode === 'purchase_option' ||
            currentPaymentNameTypeCode === 'variable_lease_payment_not_depend_on_index' ||
            (currentPaymentNameTypeCode === 'fixed_lease_payment' && currentPaymentNameKindCode === "upfront_payment");

          if(this.paymentsName[i].idInDB === newVal) {
            if(isPaymentWithoutIndexation) {
              this.availableIndexations = this.allIndexations.filter(elem => elem.typeNumber === 4);
              this.resetIndexationKindId();
              return;
            }
          } else {
            this.availableIndexations = this.allIndexations;
            this.resetIndexationKindId();
          }
        }
      }
    }
  },
  computed: {
    allIndexations() {
      return this.$store.getters['indexationPlugin/getAllIndexations'];
    },
    indexationKindId: {
      get() {
        return this.payment.indexation.indexationKindId;
      },
      set(newVal) {
        this.$store.commit('assetComponentsPlugin/updatePaymentIndexation', {
          name: 'indexationKindId',
          value: newVal,
          payment: this.payment,
          lessorComponentSharesIndex: this.lessorComponentSharesIndex,
        });

        let chosenIndexation = {};
        for (let i = 0; i < this.allIndexations.length; i++) {
          if(this.allIndexations[i].id === newVal) {
            chosenIndexation = this.allIndexations[i];
          }
        }

        if(chosenIndexation.typeNumber === 4) {
          this.$store.commit('assetComponentsPlugin/updatePaymentIndexation', {
            name: 'firstIndexationDate',
            value: null,
            payment: this.payment,
            lessorComponentSharesIndex: this.lessorComponentSharesIndex,
          });
          this.$store.commit('assetComponentsPlugin/updatePaymentIndexation', {
            name: 'indexationPercent',
            value: null,
            payment: this.payment,
            lessorComponentSharesIndex: this.lessorComponentSharesIndex,
          });

          this.isDisabledIndexationDate = true;
          this.isDisabledIndexationPercent = true;
        } else if(chosenIndexation.typeNumber === 3) {
          this.isDisabledIndexationDate = false;
          this.isDisabledIndexationPercent = true;
          this.$store.commit('assetComponentsPlugin/updatePaymentIndexation', {
            name: 'indexationPercent',
            value: 0,
            payment: this.payment,
            lessorComponentSharesIndex: this.lessorComponentSharesIndex,
          });
        } else {
          this.isDisabledIndexationDate = false;
          this.isDisabledIndexationPercent = false;
          if (this.payment.indexation.indexationPercent === 0) {
            this.$store.commit('assetComponentsPlugin/updatePaymentIndexation', {
              name: 'indexationPercent',
              value: null,
              payment: this.payment,
              lessorComponentSharesIndex: this.lessorComponentSharesIndex,
            });
          }
        }

        this.onChangeData();
      }
    },
    firstIndexationDate: {
      get() {
        if (this.payment.indexation.firstIndexationDate === null) {
          return null;
        } else {
          return dateConverter.convertToDate(this.payment.indexation.firstIndexationDate);
        }
      },
      set(newVal) {
        if(newVal !== null) {
          const firstIndexationDate = dateConverter.convertToString(newVal);

          this.$store.commit('assetComponentsPlugin/updatePaymentIndexation', {
            name: 'firstIndexationDate',
            value: firstIndexationDate,
            payment: this.payment,
            lessorComponentSharesIndex: this.lessorComponentSharesIndex,
          });
        } else {
          this.payment.indexation.firstIndexationDate = null;
        }

        this.onChangeData();
      }
    },
    indexationPercent: {
      get() {
        if (this.payment.indexation.indexationPercent !== null) {
          return this.payment.indexation.indexationPercent;
        }
      },
      set(newVal) {
        this.$store.commit('assetComponentsPlugin/updatePaymentIndexation', {
          name: 'indexationPercent',
          value: newVal,
          payment: this.payment,
          lessorComponentSharesIndex: this.lessorComponentSharesIndex,
        });
        this.onChangeData();
      }
    },
    discountPercent: {
      get() {
        if (this.payment.indexation.discountPercent !== null) {
          return this.payment.indexation.discountPercent;
        }
      },
      set(newVal) {
        this.$store.commit('assetComponentsPlugin/updatePaymentIndexation', {
          name: 'discountPercent',
          value: newVal,
          payment: this.payment,
          lessorComponentSharesIndex: this.lessorComponentSharesIndex,
        });
        this.onChangeData();
      }
    }
  },
  methods: {
    resetIndexationKindId() {
      this.$store.commit('assetComponentsPlugin/updatePaymentIndexation', {
        name: 'indexationKindId',
        value: null,
        payment: this.payment,
        lessorComponentSharesIndex: this.lessorComponentSharesIndex,
      });
    },
    onChangeData() {
      this.$emit('changeIndexation');
    },
    isFieldWithError(field, value) {
      if(!this.validationErrors || !this.validationErrors[this.payment.validationIndex]) {
        return;
      }
      return !value && this.validationErrors && this.validationErrors[this.payment.validationIndex].includes(field);
    },
    disabledDate(date) {
      const startDate = this.payment.startDate
      if(startDate === null || startDate === '') return false
      return date < dateConverter.convertToDate(startDate)
    }
  }
};
</script>
